import { useCallback, useEffect, useRef } from "react";
import { debounce } from "shared/utils";

export function useLazyEffect(effect, deps = [], wait = 250) {
  const cleanUp = useRef(null);
  const effectRef = useRef(null);
  effectRef.current = useCallback(effect, deps);
  const lazyEffect = useCallback(
    debounce(() => {
      if (cleanUp.current instanceof Function) {
        cleanUp.current();
      }
      cleanUp.current = effectRef.current?.();
    }, wait),
    []
  );
  useEffect(lazyEffect, deps);
  useEffect(() => {
    return () =>
      cleanUp.current instanceof Function ? cleanUp.current() : undefined;
  }, []);
}
